"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _misc = require("../../misc");
var _SearchableDropdown = _interopRequireDefault(require("./SearchableDropdown.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CustomListElement = function CustomListElement(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: label
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: true
  }, label));
};
CustomListElement.propTypes = {
  label: _propTypes["default"].string.isRequired
};
var handleSearchableState = function handleSearchableState(_ref2) {
  var children = _ref2.children,
    isSearching = _ref2.isSearching,
    labels = _ref2.labels,
    searchData = _ref2.searchData,
    search = _ref2.search,
    itemClick = _ref2.itemClick;
  if (isSearching) return /*#__PURE__*/_react["default"].createElement(CustomListElement, {
    label: labels.SEARCHING_LABEL
  });
  if ((0, _utils.isBlank)(searchData) && search) {
    return /*#__PURE__*/_react["default"].createElement(CustomListElement, {
      label: labels.NO_RESULTS_FOUND_LABEL
    });
  }
  return searchData.map(function (item) {
    return children && children({
      item: item,
      itemClick: itemClick
    });
  });
};
var SearchableDropdown = function SearchableDropdown(props) {
  var isFocused = props.isFocused,
    searchData = props.searchData,
    search = props.search,
    isFullWidth = props.isFullWidth;
  if (!isFocused || (0, _utils.isBlank)(searchData) && !search) return '';
  return /*#__PURE__*/_react["default"].createElement(_SearchableDropdown["default"], {
    isFullWidth: isFullWidth,
    isScrollable: R.length(searchData) > 5
  }, /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
    className: "list-menu",
    isFullWidth: isFullWidth
  }, /*#__PURE__*/_react["default"].createElement("ul", null, handleSearchableState(props))));
};
SearchableDropdown.defaultProps = {
  search: '',
  searchData: [],
  isFocused: false,
  isFullWidth: false
};
SearchableDropdown.propTypes = {
  search: _propTypes["default"].string,
  searchData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    description: _propTypes["default"].string,
    displayName: _propTypes["default"].string,
    dataSource: _propTypes["default"].string
  })),
  isFocused: _propTypes["default"].bool,
  isFullWidth: _propTypes["default"].bool
};
SearchableDropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SearchableDropdown",
  "props": {
    "search": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "searchData": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "value": {
              "name": "string",
              "required": false
            },
            "description": {
              "name": "string",
              "required": false
            },
            "displayName": {
              "name": "string",
              "required": false
            },
            "dataSource": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "isFocused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isFullWidth": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};
var _default = SearchableDropdown;
exports["default"] = _default;